var React = require('react');

function LinkLeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;}\r\n"),React.createElement("polygon",{"className":"st0","points":"1.5,11.6 13.2,0.2 16,3 7.3,11.6 16,20.2 13.2,23 ","key":1})]);
}

LinkLeftArrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16.1 23.1","style":{"enableBackground":"new 0 0 16.1 23.1"},"xmlSpace":"preserve"};

module.exports = LinkLeftArrow;

LinkLeftArrow.default = LinkLeftArrow;
